"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _ArrowBack = _interopRequireDefault(require("@material-ui/icons/ArrowBack"));
var _default = exports["default"] = function _default(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/_react["default"].createElement("button", {
    className: "w-16 h-16 shadow-lg rounded-full text-dark bg-app hover:bg-secondary",
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement(_ArrowBack["default"], null));
};
//# sourceMappingURL=OnBackButton.js.map